export default __webpack_public_path__ + "static/media/фото-126.f0c12fb8.jpg";